import { useEffect, useState } from 'react';

import { CaseAdapter } from '@shared/CaseAdapter';
import CountriesAPI from '../../../api/countries_api';

// Kept separate from funnel/fields/useCountries's narrow `Country` ({name, flag}) type: that one
// feeds the ANTS-form birth-country combobox, which has no use for exchange-status fields.
export type CountryExchangeRegion = {
  name: string;
  status: string;
  statusText: string;
  specialStatus: string;
  specialText: string;
};

export type CountryExchange = {
  iso: string;
  name: string;
  flag: string;
  category: string;
  status: string;
  statusText: string;
  specialStatus: string;
  specialText: string;
  multiregion: boolean;
  regions: CountryExchangeRegion[] | null;
};

type UseCountryExchangeDataResult = {
  countries: CountryExchange[];
  isLoading: boolean;
};

const useCountryExchangeData = (): UseCountryExchangeDataResult => {
  const [countries, setCountries] = useState<CountryExchange[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    CountriesAPI.search().then(({ data }) => {
      if (cancelled) return;
      const { countries: fetchedCountries } = CaseAdapter.toFrontFormat(data) as { countries: CountryExchange[] };
      setCountries(fetchedCountries);
      setIsLoading(false);
    }).catch((error) => {
      if (cancelled) return;
      console.error(error);
      setIsLoading(false);
    });

    return () => { cancelled = true; };
  }, []);

  return { countries, isLoading };
};

export { useCountryExchangeData };
